import * as React from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  fill: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string
};
var SvgLogoYpbMonogram = function SvgLogoYpbMonogram(_ref) {
  var fill = _ref.fill,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? null : _ref$height,
    width = _ref.width;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 40 40",
    width: width,
    height: height,
    fill: fill,
    role: "img"
  }, /*#__PURE__*/React.createElement("title", null, "your personal best"), /*#__PURE__*/React.createElement("path", {
    d: "M20 0 0 20l20 20 20-20L20 0zM5 20 20 5l15 15-15 15L5 20zm10.9-5.7 5.6 5.6-5.6 5.6 3.3 3.3 8.9-8.9-8.9-8.9-3.3 3.3z"
  }));
};
SvgLogoYpbMonogram.propTypes = propTypes;

export { SvgLogoYpbMonogram as default };
//# sourceMappingURL=LogoYpbMonogram.js.map
